<template>
  <div class="modal-overlay" @click="$emit('close')">
    <div class="modal-dialog-centered modal-base">
      <div class="modal-content">


            <div class="modal-content2" >
              <div class="modal-header">
                <h5 class="modal-title">영 수 증</h5>
                <button type="button" class="btn-close" @click="$emit('close')"></button>
              </div>
                <table class="info-table">
                    <colgroup>
                        <col width="12%">
                        <col width="88%">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>차량번호  </th>
                            <td>
                              <label> {{localRecipt.carNum}} </label>
                            </td>
                        </tr>
                        <tr>
                          <th>거래일시  </th>
                          <td>
                            <label> {{changeFormat(localRecipt.edDtti, "YYYY-MM-DD HH:mm")}} </label>
                          </td>
                        </tr>

                        <tr>
                          <th>탑승시간  </th>
                          <td>
                            <label> {{changeFormat(localRecipt.stDtti, "HH:mm")}} ~ {{changeFormat(localRecipt.payStartDtti, "HH:mm")}} ({{ meterToKilo(localRecipt.tripDist).toFixed(1) }} km) </label>
                          </td>
                        </tr>
                        <tr>
                          <th>승차요금  </th>
                          <td>
                            (  <label> {{insertComma(localRecipt.distFare) }} </label> ) /
                            (  <label> {{insertComma(localRecipt.addFare +localRecipt.callFee + localRecipt.hipassFee ) }} </label> )
                          </td>
                        </tr>
                        <tr>
                          <th>지불요금  </th>
                          <td>
                            <label> {{insertComma(localRecipt.payTotal)}} </label>
                          </td>
                        </tr>
                        <tr>
                          <th>할인요금  </th>
                          <td>
                           <label v-if="localRecipt.voucherDiscount != 0"> - </label> <label> {{insertComma(localRecipt.voucherDiscount)}} </label>

                          </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        <div class="modal-footer" style="align-items: center">
          <button class="btn btn-secondary btn-sm shadow-sm" id="saveBtn" @click="downloadTableImage">다운로드</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch , reactive} from "vue";
import {useStore} from "vuex";
import axios from "@/composables/Axios";
import tachoEntity from "@/entity/TachoEntity";
import Entity from "@/entity/OperationEntity";
import html2canvas from 'html2canvas'
import {changeFormat, insertComma, meterToKilo} from "@/components/tacho/common/CommonFunc";
const url = tachoEntity.baseUrl;
const store = useStore();
const operationUrl = store.state['api'].operationUrl;
const entity = new Entity.organizationHeaders(store.state.sign['userInfo'].userId);
const header = entity.get();
const props = defineProps({
  recipt : Object
})

const emit = defineEmits(['update:recipt'])
const localRecipt = reactive({ ...props.recipt })
const ridingFare = ref(0);
const addFare = ref(localRecipt.addFare +localRecipt.callFare + localRecipt.hipassFare);
const payFare = ref(0);
const discountFare = ref(0);

const init = () => {
}


function downloadTableImage() {
  const target = document.querySelector('.modal-content2') // 캡처할 영역 선택

  html2canvas(target).then(canvas => {
    canvas.toBlob(blob => {
      if (blob) {
        const link = document.createElement('a');
        const safeName = `영수증${localRecipt.carNum}_${localRecipt.payStartDtti}.png`;
        link.href = URL.createObjectURL(blob);
        link.download = safeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href); // 메모리 해제
      }
    }, 'image/png')
  })
}
onMounted(async () => {
    init();
})

</script>

<style scoped>
.region-list-wrapper {
  position: relative;
}

.region-list {
  margin-top: 5px;
  padding: 10px;
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  background: #fafafa;
}

.info-table {
  border-collapse: collapse;

}
.info-table th,
.info-table td {
  border: 1px solid #ddd;
  padding: 8px;
}
.modal-overlay {
  position: fixed;       /* 화면 전체 덮음 */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5); /* 반투명 배경 */
  display: flex;
  justify-content: center; /* 가로 중앙 */
  align-items: center;     /* 세로 중앙 */
  z-index: 9999;           /* 다른 요소 위에 */
}
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 12px;
  min-width: 300px;
  max-width: 600px;
  //box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.modal-content2 {
  background: white;
  padding: 20px;
  border-radius: 12px;
  //box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.modal-header {
  display: flex;
  align-items: center;   /* 세로 중앙 정렬 */
  justify-content: center; /* 기본은 가운데 정렬 */
  position: relative;    /* 닫기 버튼 위치 제어용 */
}

.modal-header .modal-title {
  flex: 1;               /* 제목이 중앙을 차지하도록 */
  text-align: center;    /* 텍스트 중앙 정렬 */
  margin: 0;
}
</style>
